import React from 'react';
import { Google, Outlook } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { ExternalConnectionsProviders } from 'shared/types/external-connections';

const providerIconMap: Record<
  ExternalConnectionsProviders,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  [ExternalConnectionsProviders.Google]: Google,
  [ExternalConnectionsProviders.Outlook]: Outlook,
};

export type ExternalConnectionIconProps = {
  provider: ExternalConnectionsProviders;
};

export const ExternalConnectionIcon: React.FC<ExternalConnectionIconProps> = ({
  provider,
}) => <Icon icon={providerIconMap[provider]} />;
